import { render, staticRenderFns } from "./Limits.vue?vue&type=template&id=4ccf89de&scoped=true"
import script from "./Limits.vue?vue&type=script&lang=ts"
export * from "./Limits.vue?vue&type=script&lang=ts"
import style0 from "./Limits.vue?vue&type=style&index=0&id=4ccf89de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ccf89de",
  null
  
)

export default component.exports